export const FETCH_USER = 'fetch_user';
export const LOGIN_REQ = 'LOGIN_REQ';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
